import { ArrowForward } from '@mui/icons-material';
import { Box, Button, SxProps, Theme, Typography } from '@mui/material';

import { appleLogo, googleLogo } from '@/images';
import { AnalyticsService, EVENTS } from '@/services';
import { getOauthURL } from '@/utils';

type OauthButtonProps = {
  type: 'google' | 'apple';
  sx?: SxProps<Theme>;
  marketingConsent?: boolean;
};

export const OauthButton = ({
  type,
  sx,
  marketingConsent,
}: OauthButtonProps) => {
  return (
    <Button
      fullWidth
      sx={[styles.oauthButton, ...(Array.isArray(sx) ? sx : [sx])]}
      onClick={() => {
        AnalyticsService.logEvent(EVENTS.AUTH_EVENTS.SSO_REDIRECT, {
          method: type === 'google' ? 'google oauth' : 'apple oauth',
        });
        window.location.href = getOauthURL(type, marketingConsent);
      }}>
      <Box sx={styles.oauthButtonLabel}>
        <Box
          component="img"
          alt={`${type} logo`}
          src={type === 'google' ? googleLogo : appleLogo}
          sx={{ height: 24 }}
        />
        <Typography variant="body2SemiBold">
          Continue with {type === 'google' ? 'Google' : 'Apple'}
        </Typography>
      </Box>
      <ArrowForward
        sx={{
          fontSize: 24,
          color: 'blueBlack',
        }}
      />
    </Button>
  );
};

const styles = {
  oauthButton: {
    height: 48,
    fontSize: 16,
    backgroundColor: 'white',
    color: 'blueBlack',
    borderRadius: 2,
    border: (theme: Theme) => `1px solid ${theme.palette.grey100}`,
    display: 'flex',
    justifyContent: 'space-between',
    p: 1.5,
  },
  oauthButtonLabel: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'none',
    gap: 2,
  },
};
